import React, { useState } from "react";
import classnames from 'classnames';
import './UserDefaultsAndPreferences.scss';
import { UserDefaultSelections } from "./UserDefaultSelections";
import { DefaultsEditor } from "./DefaultsEditor";
import { ByzzerMask } from "../ByzzerMask/ByzzerMask";
import { DatasetTypePicker } from "./DatasetTypePicker/DatasetTypePicker";
import { ReportDatatype } from "@/types/ReportRun";

export type NewUserPreferencesProps = {}

const baseClassName = 'byz-user-preferences';

export const UserDefaultsAndPreferences = ({}: NewUserPreferencesProps) => {

    const [showDefaultsEditor, setShowDefaultsEditor] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedDataset, setSelectedDataset] = useState<ReportDatatype>('rms');

    function handleLoading(loading: boolean) {
        setLoading(loading);
    }

    function handleCancel() {
        setShowDefaultsEditor(false);
    }

    function handleEditModeClick() {
        setShowDefaultsEditor(true);
    }

    function handleDatasetChange(dataset: ReportDatatype) {
        setSelectedDataset(dataset);
    }

    return (
        <div className={classnames(`${baseClassName}`)}>
            <ByzzerMask show={loading} loading={loading} isFullScreen={true}>Saving Preferences...</ByzzerMask>

            {showDefaultsEditor ? (
                <DefaultsEditor onCancel={handleCancel} setLoading={handleLoading} selectedDataset={selectedDataset} />
            ) : (
                <div className={classnames(`${baseClassName}__display`)}>
                    <DatasetTypePicker value={selectedDataset} onChange={handleDatasetChange} />
                    <UserDefaultSelections 
                        onEditModeClick={handleEditModeClick}
                        selectedDataset={selectedDataset}
                    />
                </div>
            )}
        </div>
    );
};

export default UserDefaultsAndPreferences;

UserDefaultsAndPreferences.displayName = 'UserDefaultsAndPreferences';